import React from 'react';
import CompanySuggestion from '~/src/components/common-components/company-suggestion/company-suggestion';
import type {
    CompanySuggestionProps,
} from '~/src/components/common-components/company-suggestion/company-suggestion.types';
import type {
    PrepareDataType,
} from '~/src/components/blocks/clients-request/organization-info/organization-info.types';

export const prepareDataFromDropDown: PrepareDataType<CompanySuggestionProps> = ({ data = [], callback }) => {
    return data?.map((item, key) => ({
        id: item.ogrn || item.inn || String(key),
        value: item?.fullName || item?.name?.fullName || '',
        Component: callback(data),
    }));
};

export const getComponentCompanySuggestions = (data: CompanySuggestionProps[] | []): JSX.Element[] => {
    return (
        data.map((elem, index) => (
            <CompanySuggestion key={elem?.name?.fullName || '' + index} {...elem} />
        ))
    );
};